import { useNavigate } from "react-router-dom";
import SciensHaloLogo from "../utils/SciensHaloLogo.svg";
import Landingpagebg from "../utils/Landingpagebg.svg";
import { useEffect } from "react";
import { clearAuthData, getAuthItem } from "../utils/indexDB";

const ObcLanding = () => {
  const navigate = useNavigate();

  const bufferHours = 3;
  function isTokenExpired(token) {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expiry = payload.exp * 1000; // convert to ms
    const bufferMs = bufferHours * 60 * 60 * 1000;

    return Date.now() + bufferMs > expiry;
  }

  useEffect(() => {
    const CheckToken = async () => {
      const token = await getAuthItem("accessToken");
      const email = await getAuthItem("userEmail");

      if (token && !isTokenExpired(token) && email) {
        // proceed to home
        navigate("/home");
      } else {
        clearAuthData();
      }
    };
    CheckToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative h-screen flex flex-col">
      <div
        className="bg-cover bg-center flex-1 flex flex-col items-center px-6 pt-20  justify-end"
        style={{ backgroundImage: `url(${Landingpagebg})` }}
      >
        <div className="w-full max-w-md flex flex-col items-center gap-12">
          <div className="">
            <img src={SciensHaloLogo} alt="SciensLogistics Halo Logo" />
          </div>

          <div className="text-center ">
            <h1 className="text-2xl font-bold text-gray-500 mb-4">
              Welcome to Partner Portal
            </h1>
            <p className="text-gray-400 text-sm">
              Your one-stop solution for managing installations, updating work
              status, and sharing photos of completed assignments.
            </p>
          </div>

          <div className="w-full space-y-4">
            <button
              onClick={() => navigate("/signup")}
              className="w-full bg-primary-500 text-white py-3 rounded-lg font-medium hover:bg-primary-500 transition-colors"
            >
              Sign up as an OBC
            </button>
            <button
              onClick={() => navigate("/login")}
              className="w-full bg-primary-900  text-white py-3 rounded-lg font-medium hover:bg-primary-900 transition-colors"
            >
              Login
            </button>
          </div>

          <div className="mt-auto pb-6 pt-8">
            <p className="text-gray-500 text-sm">© Sciens Logistics LLC</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ObcLanding;
